import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './css/Positions.scss';

@injectIntl
export default class Summary extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        order: PropTypes.any,
        services: PropTypes.any,
    }

    render() {
        const { order } = this.props;

        if (!order.has('positions')) {
            return null;
        }

        return (
            <div>
                <h3>
                    <FormattedMessage id='frontend.orders_detail.headline.positions' />
                </h3>
                <ul className={styles.list}>
                    {
                        order.get('positions')
                            .map(position => (
                                <li key={position.get('id')}>
                                    {position.get('parcels').count()} x {' '}
                                    <FormattedMessage id={position.getIn(['product', 'alias'])} /> {' '}
                                    <span>
                                        (<FormattedMessage id={position.getIn(['service', 'alias'])} />)
                                    </span>
                                </li>
                            ))
                            .toArray()
                    }
                </ul>
            </div>
        );
    }
}
